module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/Frame175-6e16157289866506b4d4022ff80804e0.png";